/*
 * @Author: yusha
 * @Date: 2024-01-23 17:03:59
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-07 11:35:44
 * @Description:
 */
import { t } from '@/plugins/i18n'

/** /order/cart/create/order 下单成功，返回信息 */
export interface OrderSuccessInfoDTO {
  /** 平台订单id */
  platformOrderId?: number;
  /** THE CKB订单编号 */
  platformOrderNo?: string;
  /** 是否下单成功 */
  success?: boolean;
  /** 实际下单的金额 */
  totalFreezeAmount: number;
  /** 订单预估总价 */
  estimatedTotalOrderPrice?: number;
  /** 任务id */
  taskId?: number;
  /** 订单预估总价 */
  customerOrderNo?: string;
  /** 任务id */
  message?: string;
  code?: number;
}
/** 一键下单在途库存的column */
export const stockOneclickColumns: any = [
  {
    label: t('商品信息'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'productSkuImg',
    width: 280
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center'
    // width: 120
  },

  {
    label: t('购买数'),
    prop: 'skuOrderNum',
    slotName: 'skuOrderNum',
    align: 'center'
    // width: 120
  },
  {
    label: t('处理中库存使用数'),
    prop: 'onTheWayAvailableNum',
    align: 'center'
  }
]

export const tableConfigStockOneclick = {
  showSelection: false,
  // showHandler: true,
  setHeight: false
  // handlerConfig: { label: t('处理方式'), align: 'center' }
}
